// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2ADBJ","colCheckbox":"styles_colCheckbox__V2xkB"};